export function normaliseUSPhoneNumber(phoneNumberString: string | undefined) {
    if (phoneNumberString) {
        if (phoneNumberString?.length > 1 && phoneNumberString.startsWith('+1')) {
            phoneNumberString = phoneNumberString.substring(2);
        }

        const cleaned = ('' + phoneNumberString).replace(/\D/g, '');

        return cleaned;
    }

    return '';
}